export default "__VITE_ASSET___ddTLi6k__"